<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">系統權限管理</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="dialogShow=true">新增</v-btn>
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportFile" :loading="isExporting">匯出</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="sysuserList"
        :headers="headers"
        hide-default-header
        :items-per-page="rows"
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td
              v-for="header in headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='action'">
                <v-icon
                  size = "35"
                  color="primary"
                  @click="editData(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  size = "35"
                  class="ml-2"
                  color="red"
                  @click="openDeleteRoleDialog(item)"
                >
                  mdi-delete
                </v-icon>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 新增編輯dialog -->
      <v-dialog overlay-opacity="0.2" max-width="1000px" v-model="dialogShow" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">系統權限管理</v-card-title>
          <v-card-text>
            <div class="contentCenter">
              <v-btn-toggle
                v-model="dialogType"
                mandatory
              >
                <v-btn value="basicInfo" class="btn_fontSize">
                  基本資料
                </v-btn>
                <v-btn value="person" class="btn_fontSize" :disabled="!isEdit">
                  授權人員
                </v-btn>
                <v-btn value="page" class="btn_fontSize" :disabled="!isEdit">
                  系統選單
                </v-btn>
              </v-btn-toggle>
            </div>
            <div class="contentCenter" v-if="!isEdit">
              <span>請先創建群組名稱再進行其他操作</span>
            </div>
            <div class="rowDiv contentCenter mt-5" v-if="dialogType=='basicInfo'">
              <div style="width:220px; height:30px">
                <v-text-field
                  v-model="basicinfo.RoleName"
                  class="rounded-lg"
                  dense
                  outlined
                  hide-details
                  label="權限群組名稱"
                  :rules="rules.content"
                ></v-text-field>
              </div>
            </div>
            <div class="rowDiv contentCenter mt-5" v-if="dialogType=='person'">
              <div class="rowDiv" style="width: 750px">
                <div>
                  <v-btn depressed  color="success" class="btn_fontSize ml-6" @click="openAddPersonDialog">新增</v-btn>
                </div>
                <v-spacer>
                </v-spacer>
                <div class="text-center mr-5">
                  <v-pagination
                    circle
                    v-model="PIRPage"
                    :length="PIRPageCount"
                    total-visible=7
                  ></v-pagination>
                </div>
                <v-divider
                  class="tableDivider mr-5"
                  vertical
                  inset
                >
                </v-divider>
                <div class="text-center mr-5 contentCenter">
                  共{{PIRTotal}}筆
                </div>
              </div>
              <v-data-table
                class="elevation-1 rounded-lg ml-auto mr-auto"
                hide-default-footer
                :items="PIRList"
                :headers="PIRheaders"
                hide-default-header
                :items-per-page="10"
                :page.sync="PIRPage"
              >
                <template v-slot:header>
                  <thead>
                    <tr>
                      <th
                        class="greyTh"
                        v-for="header in PIRheaders"
                        :key="header.value"
                      >
                        <div
                          :style="'width:'+header.width+'px'"
                          @click="changeSort(header)"
                          class="sortableThDiv"
                        >
                          <div class="sortableThDivText">
                            {{header.text}}
                          </div>
                          <div v-if="header.sortable&&sortItem===header.value">
                            <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                            <v-icon v-else>mdi-chevron-up</v-icon>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td
                      v-for="header in PIRheaders"
                      :key="header.value"
                      class="tableTD"
                    >
                      <div v-if="header.value==='action'">
                        <v-icon
                          size = "35"
                          class="ml-2"
                          color="red"
                          @click="openDeletePersonDialog(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </div>
                      <div v-else>
                        {{item[header.value]}}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  no data available
                </template>
              </v-data-table>
            </div>
            <div class="rowDiv contentCenter mt-5" v-if="dialogType=='page'">
              <div>
                <div v-for="item in tree" :key="item.id">
                  <div class="mt-2" v-if="item.lv==1&&item.children.length>0">
                    <v-card-title class="headline font-weight-bold pt-3 pb-0">{{item.text}}</v-card-title>
                    <v-card-title class="headline text-subtitle-2 pt-0 pb-0" v-if="item.text == '系統維護管理'">*需額外設定以啟用功能</v-card-title>
                  </div>
                  <div class="mt-2" v-else>
                    <v-card-title class="headline font-weight-bold">{{item.text}}</v-card-title>
                  </div>
                  <div class="rowDiv" v-for="children in item.children" :key="children.id">
                    <v-checkbox dense hide-details
                      v-model="children.checked"
                      style="white-space: initial;"
                      class="ml-10"
                      @change="leftInput(children, children.checked)"
                      :label="children.text"
                    ></v-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="mt-5">
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn cancelBtnColor" @click="dialogClose">關閉</v-btn>
            <v-btn class="dialogbtn subBtnColor" @click="dialogSave">確認</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增人員dialog -->
      <v-dialog overlay-opacity="0.2" max-width="800px" v-model="dialogAddPerson" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">新增人員</v-card-title>
          <v-card-text>
            <div class="rowDiv contentCenter">
              <div class="rowDiv pb-2" style="width: 750px">
                <v-spacer>
                </v-spacer>
                <div class="text-center mr-5">
                  <v-pagination
                    circle
                    v-model="APPage"
                    :length="APPageCount"
                    total-visible=7
                  ></v-pagination>
                </div>
                <v-divider
                  class="tableDivider mr-5"
                  vertical
                  inset
                >
                </v-divider>
                <div class="text-center mr-5 contentCenter">
                  共{{APTotal}}筆
                </div>
              </div>
              <v-data-table
                class="elevation-1 rounded-lg ml-auto mr-auto"
                hide-default-footer
                :items="userList"
                :headers="PIRheaders"
                hide-default-header
                :items-per-page="10"
                :page.sync="APPage"
              >
                <template v-slot:header>
                  <thead>
                    <tr>
                      <th
                        class="greyTh"
                        v-for="header in PIRheaders"
                        :key="header.value"
                      >
                        <div
                          :style="'width:'+header.width+'px'"
                          @click="changeSort(header)"
                          class="sortableThDiv"
                        >
                          <div class="sortableThDivText">
                            {{header.text}}
                          </div>
                          <div v-if="header.sortable&&sortItem===header.value">
                            <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                            <v-icon v-else>mdi-chevron-up</v-icon>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td
                      v-for="header in PIRheaders"
                      :key="header.value"
                      class="tableTD"
                    >
                      <div v-if="header.value==='action'">
                        <v-checkbox
                          color="success"
                          style="margin: auto;"
                          v-model="item.add"
                          hide-details
                        ></v-checkbox>
                      </div>
                      <div v-else>
                        {{item[header.value]}}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  no data available
                </template>
              </v-data-table>
            </div>
          </v-card-text>
          <v-card-actions class="mt-0 pb-5">
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn cancelBtnColor" @click="dialogAddPerson=false">關閉</v-btn>
            <v-btn class="dialogbtn subBtnColor" @click="AddPerson">確認</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 確認刪除權限群組dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="dialogDeleteRole" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除權限群組</v-card-title>
          <v-card-text>
            <v-form ref="deleteRoleForm">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="權限群組編號"
                    v-model="dialogItemRole.Role_Id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="權限群組名稱"
                    v-model="dialogItemRole.RoleName"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDeleteRoleDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteRole">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 確認刪除使用者權限群組dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="dialogDeletePerson" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除權限群組使用者</v-card-title>
          <v-card-text>
            <v-form ref="deletePersonForm">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="權限群組人員編號"
                    v-model="dialogItemPerson.USERID"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="權限群組人員姓名"
                    v-model="dialogItemPerson.USERNAME"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDeletePersonDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deletePerson">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebarWidth"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5"
            v-if='sidebarOpen'
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-arrow-expand-left
          </v-icon>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5 mt-5"
            v-else
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-tune-variant
          </v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebarOpen">
          <v-card-title style="height:50px;" class="searchTitle">權限群組編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchRoleId"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">權限群組名稱</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchRoleName"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
export default {
  name: 'Sys_Role',
  data: () => ({
    isLoading: false,
    isExporting: false,
    headers: [
      { text: '權限群組編號	', value: 'Role_Id', width: '200', sortable: true },
      { text: '權限群組名稱', value: 'RoleName', width: '300', sortable: true },
      { text: '', value: 'action', width: '100', sortable: true }
    ],
    PIRheaders: [
      { text: '', value: 'action', width: '100', sortable: true },
      { text: '人員ID	', value: 'value', width: '200', sortable: true },
      { text: '人員', value: 'text', width: '300', sortable: true },
    ],
    startDateMenu: false,
    startDate: '',
    endDateMenu: false,
    endDate: '',
    rows: 10,
    sortItem: 'Role_Id',
    sortOrder: false,
    total: 0,
    pageCount: 0,
    page: 1,
    sysuserList: [],
    detailItem: '',
    dialogShow: false,
    sidebarOpen: true,
    sidebarWidth: 260,
    searchRoleId: '',
    searchRoleName: '',
    dialogType: 'basicInfo',
    rowsList: [10, 20, 30, 40, 50],
    basicinfo: {
      ParentId: 1,
      Role_Id: 0,
      RoleName: '',
      Enable: 1,
      CreateDate: '',
      Creator: '',
      DeptName: '',
      Modifier: '',
      ModifyDate: '',
      DSMSRoleId: ''
    },
    isEdit: false,
    rules: {
      content: [v => !!v || 'Required']
    },
    PIRPageCount: 0,
    PIRPage: 1,
    PIRTotal: 0,
    PIRList: [],
    dialogAddPerson: false,
    APPageCount: 0,
    APPage: 1,
    APTotal: 0,
    updateTime: 0,
    data: [],
    tree: [],
    pickedRole: -1,
    rolePermission: [],
    userList: [],
    userGroupsList: [],
    dialogDeleteRole: false,
    dialogDeletePerson: false,
    dialogItemRole: { Role_Id: '', RoleName: '' },
    dialogItemPerson: { USERID: '', USERNAME: '' },
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.getDictionary()
    this.getPermissionTree()
  },
  watch: {
    page () {
      this.getPageData()
    },
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },
    rows () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchRoleId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchRoleName () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    dialogType () {
      // console.log(this.dialogType)
      // console.log(this.isEdit)
      if (this.dialogType === 'person' && this.isEdit) {
        this.getPersonInRole()
      } else if (this.dialogType === 'page' && this.isEdit) {
        this.roleSelected()
      }
    },
    updateTime () {
      if (this.updateTime === this.userList.filter(x => x.add===true).length)
      {
        this.getDictionary()
      }
    }
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    getDictionary () {
      var parm = ['USERS', 'USERGROUPS']
      Service.getDictionary(parm)
        .then((response) => {
          // og(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            this.userList = []
            this.userGroupsList = []
            var userIndex = response.data.map(function (item) { return item.dicNo }).indexOf('USERS')
            var userGroupsIndex = response.data.map(function (item) { return item.dicNo }).indexOf('USERGROUPS')
            var userList = response.data[userIndex].data
            var userGroupsList = response.data[userGroupsIndex].data
            userList.forEach(element => {
              var user = {
                value: element.key,
                text: element.value
              }
              this.userList.push(user)
            })
            userGroupsList.forEach(element => {
              var userGroups = {
                value: element.key,
                text: element.value
              }
              this.userGroupsList.push(userGroups)
            })
            this.APPage = 1
            this.APTotal = this.userList.length
            this.APPageCount = Math.ceil(this.APTotal / 10)
            this.getPersonInRole()
            this.getPageData()
          }
        })
    },
    getPageData () {
      this.isLoading = true
      this.pageCount = 0
      this.sysuserList = []
      var searchRoleId = {
        name: 'Role_Id',
        value: this.searchRoleId,
        displayType: '='
      }
      var searchRoleName = {
        name: 'RoleName',
        value: this.searchRoleName,
        displayType: '='
      }
      var wheres = [searchRoleId, searchRoleName]
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'Sys_Role/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.total = response.data.total
            this.pageCount = Math.ceil(this.total / this.rows)
            this.sysuserList = response.data.rows
          }
        })
      .finally(() => {
        this.isLoading = false
      })
    },
    dialogClose () {
      this.dialogShow = false
      this.basicinfo.RoleName = ''
      this.dialogType = 'basicInfo'
      this.getPageData()
      this.getPermissionTree()
      this.isEdit = false
    },
    dialogSave () {
      if (this.dialogType == 'basicInfo') {
        this.saveBasicInfo()
        this.getDictionary()
        this.isEdit = true
      } else if (this.dialogType == 'page') {
        this.updatePermission()
      } else {
        this.dialogClose()
      }
    },
    saveBasicInfo () {
      const url = this.isEdit? '/Sys_Role/Update':'/Sys_Role/Add'
      // console.log(this.isEdit)
      // Ian, 2023-10-17, 編輯時不調整對應的 DSMSRoleId, 以避免同步更新 USERGROUP 中的資料
      if(!this.isEdit){
        this.basicinfo.DSMSRoleId = this.basicinfo.RoleName
      }

      Service.updateData(this.basicinfo, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.basicinfo.Role_Id = JSON.parse(response.data.data).data.Role_Id
            this.showAlert('success', '操作成功')
            this.getPageData()
          }
        })
    },
    deleteData (item) {
      // console.log(item)
      var deleteList = []
      deleteList.push(item.Role_Id)
      const url = '/Sys_Role/del'
      Service.deleteData(deleteList, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
            this.deleteList = []
            this.getPageData()
          }
        })
    },
    editData (item) {
      this.isEdit = true
      this.basicinfo = item
      this.dialogShow = true
      this.roleSelected()
      this.getPersonInRole()
    },
    getPersonInRole () {
      this.PIRList = []
      // console.log(this.basicinfo)
      var userIdList = []
      this.userGroupsList.forEach(element => {
        if (this.basicinfo.Role_Id === element.text)
        userIdList.push(element.value)
      })
      this.userList.forEach(element => {
        if(userIdList.includes(element.value)) {
          this.PIRList.push(element)
        }
      })
      this.PIRPage = 1
      this.PIRTotal = this.PIRList.length
      if (this.PIRTotal >= 10) {
        this.PIRPageCount = Math.ceil(this.PIRTotal / 10)
      } else {
        this.PIRPageCount = 1
      }
      // console.log(this.PIRList)
    },
    openAddPersonDialog () {
      this.dialogAddPerson = true
      this.getDictionary()
    },
    AddPerson () {
      this.updateTime = 0
      Promise.all(Array.from(this.userList).map((element) => {
         if (element.add) {
          element.USERID = element.value
          element.GROUPID = this.basicinfo.DSMSRoleId
          this.UpdatePerson(element)
        }
      }))
      this.dialogAddPerson = false
    },
    UpdatePerson (item) {
      const url = '/USERGROUPS/Add'
      Service.updateData(item, url)
        .then((response) => {
          // console.log(item.User_Id)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', '操作成功')
            this.updateTime ++
          }
        })
    },
    getPermissionTree () {
      var showList = [
        '基本設定',
        '發報管理',
        '系統管理',
        '系統維護管理'
      ]
      const url = '/Sys_Role/GetDSMSCurrentTreePermission'
      var data = ''
      Service.getDetailData(data, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            const respData = response.data.data
            this.data.splice(0)
            this.tree = []
            this.data = respData.tree

            // Ian, 2023-10-23, 依照正確的順序取回資訊
            showList.forEach(element => {
              this.data.forEach(x => {
                if (x.pid === 0) {
                  x.lv = 1
                  x.children = []
                  // console.log(x)
                  if (element === x.text) {
                    this.tree.push(x)
                  }
                  this.getTree(x.id, x)
                }
              })
            })
          }
        })
    },
    getTree (id, data) {
      this.data.forEach(x => {
        if (x.pid === id) {
          x.lv = data.lv + 1
          if (!data.children) data.children = []
          x.checked = false
          data.children.push(x)
          this.getTree(x.id, x)
        }
      })
    },
    leftInput (nodes, checked) {
      // console.log(nodes)
      // console.log(checked)
      if (checked) {
        this.rolePermission.push(nodes)
      } else {
        var index = this.rolePermission.findIndex(x => x.id === nodes.id)
        if (index !== -1) {
          this.rolePermission.splice(index, 1)
        }
      }
      // console.log(this.rolePermission)
    },
    roleSelected () {
      // console.log(this.basicinfo)
      this.pickedRole = this.basicinfo.Role_Id

      this.data.forEach(x => {
        x.actions.forEach(a => {
          this.$set(a, 'checked', false)
        })
      })
      const url = '/role/GetDSMSUserTreePermission?roleId=' + this.basicinfo.Role_Id
      var data = ''
      Service.getDetailData(data, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            var respData = response.data.data
            this.rolePermission = respData
            // console.log(this.rolePermission)
            respData.forEach(item => {
              if (item.actions.length !== 0) {
                // console.log(item.id)
                var sourceItem = null
                this.tree.forEach(child => {
                  sourceItem = child.children.find(f => f.id === item.id)
                  if (sourceItem) {
                    // console.log(sourceItem)
                    sourceItem.checked = true
                    this.$set(sourceItem, 'checked', true)
                    return
                  }
                })
                
              }
            })
            // console.log(this.tree)
          }
        })
    },
    updatePermission () {
      const url = '/role/SavePermission?roleId=' + this.basicinfo.Role_Id
      Service.updatePermission(this.rolePermission, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', '操作成功')
          }
        })
    },
    exportFile () {
      this.isExporting = true
      var searchRoleId = {
        name: 'Role_Id',
        value: this.searchRoleId,
        displayType: '='
      }
      var searchRoleName = {
        name: 'RoleName',
        value: this.searchRoleName,
        displayType: '='
      }
      var wheres = [searchRoleId, searchRoleName]
      var parm = {
        wheres: JSON.stringify(wheres),
        url: 'Sys_Role/Export'
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = '系統權限管理.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.isExporting = false
      })
    },
    openDeleteRoleDialog (item) {
      // console.log(item)
      this.dialogDeleteRole = true
      this.dialogItemRole = {
        Role_Id: item.Role_Id,
        RoleName: item.RoleName
      }
    },
    closeDeleteRoleDialog () {
      this.dialogDeleteRole = false
      if (this.$refs.deleteRoleForm) {
        this.$refs.deleteRoleForm.resetValidation()
        this.dialogItemRole = {
          Role_Id: '',
          RoleName: ''
        }
      }
    },
    deleteRole () {
      if (this.$refs.deleteRoleForm) {
        this.$refs.deleteRoleForm.resetValidation()
        
        var deleteList = []
        deleteList.push(this.dialogItemRole.Role_Id)
        const url = '/Sys_Role/del'
        Service.deleteData(deleteList, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData()
              this.dialogDeleteRole = false
            }
          })
      }
    },
    openDeletePersonDialog (item) {
      // console.log(item)
      this.dialogDeletePerson = true
      this.dialogItemPerson = {
        USERID: item.text,
        USERNAME: item.value
      }
    },
    closeDeletePersonDialog () {
      this.dialogDeletePerson = false
      if (this.$refs.deletePersonForm) {
        this.$refs.deletePersonForm.resetValidation()
        this.dialogItemPerson = {
          USERID: '',
          USERNAME: ''
        }
      }
    },
    deletePerson () {
      if (this.$refs.deletePersonForm) {
        this.$refs.deletePersonForm.resetValidation()
        
        const url = '/USERGROUPS/del_custom'
        Service.updateData({USERID: this.dialogItemPerson.USERNAME, GROUPID: this.basicinfo.DSMSRoleId}, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getDictionary()
              this.dialogDeletePerson = false
            }
          })
      }
    },
  }
}
</script>
